import styled from 'styled-components';
import {
  brandYellowgreen,
  grayMediumSphera,
  supportMiddleGreen
} from 'src/utilities/UIStyles/variables/Colors';
import { finspheraTypography } from '../../../../utilities/UIStyles/variables/typography';
import { breakpoints } from '../../../../utilities/UIStyles/variables/breakpoints';

export const GeneralLoader = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100vw;
  height: 100vh;
  background-color: white;
  position: fixed;
  justify-content: center;
  align-items: center;
  z-index: 1005;
  background-color: rgba(0, 0, 0, 0.6);

  .message-container {
    display: flex;
    text-align: center;
    position: relative;
    bottom: -6rem;
    width: 90%;

    h2 {
      font-size: ${finspheraTypography.fontSize.large};
      color: ${brandYellowgreen};
    }
  }

  > p {
    width: 100%;
  }
  > span {
    position: relative;
  }
  > span::before,
  span::after {
    content: ' ';
    position: absolute;
    left: 37%;
    transform: translate(-50%, 100%);
    background: ${grayMediumSphera};
    width: 30px;
    height: 30px;
    border-radius: 50%;
    animation: jump 0.5s ease-in infinite alternate;
  }
  > span::after {
    background: ${supportMiddleGreen};
    color: ${brandYellowgreen};
    top: 100%;
    box-shadow: 320px -20px, -320px -20px;
    animation: split 0.5s ease-out infinite alternate;
  }
  @keyframes split {
    0% {
      box-shadow: 8px -20px, -8px -20px;
    }
    100% {
      box-shadow: 120px -20px, -120px -20px;
    }
  }
  @keyframes jump {
    0% {
      transform: translate(-50%, -350%);
    }
    100% {
      transform: translate(-50%, 200%);
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    .message-container {
      width: 50%;
    }
  }
`;
